import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=6e65f6fe&scoped=true"
import script from "./ui-button.vue?vue&type=script&lang=ts"
export * from "./ui-button.vue?vue&type=script&lang=ts"
import style0 from "./ui-button.vue?vue&type=style&index=0&id=6e65f6fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e65f6fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e65f6fe')) {
      api.createRecord('6e65f6fe', component.options)
    } else {
      api.reload('6e65f6fe', component.options)
    }
    module.hot.accept("./ui-button.vue?vue&type=template&id=6e65f6fe&scoped=true", function () {
      api.rerender('6e65f6fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/ui-button.vue"
export default component.exports